const PASeoLinks =
    ["/practice-area/family_law", "/practice-area/child_custody", "/practice-area/separation_and_divorce",
        "/practice-area/spousal_support", "/practice-area/child_support", "/practice-area/matrimonial_home",
        "/practice-area/employment_and_benefits", "/practice-area/wrongful_dismissal_or_discrimination",
        "/practice-area/contracts_(new_job_or_termination)",
        "/practice-area/wills_and_estates", "/practice-area/estate_litigation",
        "/practice-area/prenuptial_and_co-habitation_agreements"];

export default PASeoLinks;